import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Table, Checkbox, Alert, Button } from 'antd';
import './manageTowItems.css';
import manageTowItemTableHeader from '../../model/TowItemSelectionTableHeader';
import Translation from '../../Translation';

/**
 * class manages the tow items of companies
 *  
 * @class ManageTowItems 
 * @extends {Component}
 */
class ManageTowItems extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: [],
            defaultRows: [],
            selectedRowKeys: [],
            isViewSelectedChecked: false,
            loading: true,
            alertDisplay: 'displayNone',
            btnLoading: false
        };

        this.handleUpdate = this.handleUpdate.bind(this);
        this.toggleViewSelectedCheck = this.toggleViewSelectedCheck.bind(this);
        this.getSelectedItems = this.getSelectedItems.bind(this);
        this.viewSelectedItems = this.viewSelectedItems.bind(this);
    }

    /**
     * handleUpdate function updates the new tow items to the particular company
     *
     * @memberof ManageTowItems
     */
    handleUpdate() {
        this.setState({
            btnLoading: true
        });
        this.props.getUpdatedItems(this.state.selectedRowKeys);
    }

    componentWillReceiveProps(newProps) {
        let items = newProps.itemData;
        let selectedItems = newProps.items || [];
        if (items) {
            this.getTowItems(items, selectedItems);
        }

        this.setState({
            isViewSelectedChecked: false,
            btnLoading: false
        });
    }

    UNSAFE_componentWillMount() {
        this.getTowItems(undefined, this.props.items);
    }
    /**
     *
     * getTowItems function displays the table containing all the tow items with selected ones of the
     * particular company.
     * 
     * @param {object} propsData
     * @param {object} someItems
     * @memberof ManageTowItems
     */
    getTowItems(propsData, someItems) {
        let items = this.props.itemData.length ? this.props.itemData : propsData;
        if (items && items.length) {
            let headers = Object.keys(items[0]).filter(item => {
                switch (item) {
                    case 'id':
                    case 'createdAt':
                    case 'updatedAt':
                    case 'minwt2':
                    case 'mixpddry':
                    case 'tgtwtdry':
                    case 'tgtpddry':
                    case 'maxwtdry':
                    case 'maxpddry':
                    case 'tgtpd':
                        break;
                    default:
                        return item;
                }
                return !1;
            });

            let newData = items.map((obj) => {
                var Obj = {};
                headers.map(header => {
                    if (header === 'plantcode') {
                        let plants = {
                            "C": "Celco",
                            "O": "Ocotlan",
                            "L": "Lanaken",
                            "S": "Spondon"
                        };
                        Obj[header] = plants[obj[header]] || obj[header];
                    } else {
                        Obj[header] = obj[header];
                    }
                    return Obj;
                });
                return Obj;
            });

            this.setState({
                rows: newData,
                defaultRows: newData
            }, () => {
                this.viewSelectedItems(someItems);
            });
        }

    }

    /**
     * viewSelectedItems function displays the selected tow items 
     *
     * @param {object} selectedItems
     * @memberof ManageTowItems
     */
    viewSelectedItems(selectedItems) {
        let data = this.state.rows;
        let a = data.filter(e => {
            return selectedItems.filter(f => f.itemlot === e.itemlot).length !== 0;
        });

        if (selectedItems.length !== a.length) {
            this.setState({
                alertDisplay: 'displayBlock'
            });
        }

        const itemLotsProps = a;
        const itemLotsArr = itemLotsProps.length ? (
            itemLotsProps.map(function (item) {
                return item.itemlot || item;
            })
        ) : (
                []
            );

        this.setState({
            selectedRowKeys: itemLotsArr,
            loading: false
        }, () => {
            this.props.closeLoading();
            this.toggleViewSelectedCheck();
        });
    }
    /**
     *
     * getSelectedItems creates an array of all the selected items in the tow item table
     *
     * @memberof ManageTowItems
     */
    getSelectedItems() {
        var data = this.state.rows;
        let selectedItems = this.state.selectedRowKeys;
        var finalArr = [];
        for (let item of selectedItems) {
            let result = data.find(element => element.itemlot === item);
            if (result) {
                finalArr = finalArr.concat(result);
            }
        }
        this.setState({
            rows: finalArr
        });
    }
    /**
     * toggleViewSelectedCheck toggle between selected items data and all the tow items data
     *
     * @memberof ManageTowItems
     */
    toggleViewSelectedCheck() {
        this.setState({ isViewSelectedChecked: !this.state.isViewSelectedChecked }, function () {

            if (this.state.isViewSelectedChecked) {
                this.getSelectedItems();
            }
            else {
                this.setState({
                    rows: this.state.defaultRows
                });
            }
        });
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys });
    }

    render() {
        const { selectedRowKeys, isViewSelectedChecked } = this.state;
        let rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };

        if (isViewSelectedChecked) {
            rowSelection = null;
        }

        return (
            <div className="manage-tow-items">
                <h2 className="manage-tow-items__title"><Translation labelName="title_admin_manage_tow_items" defaultText="Manage Tow Items" /></h2>
                <h3 className="manage-tow-items__company">{this.props.companyName}</h3>
                <div className="manage-wrapper">
                    <h4 className="manage-wrapper__title"><Translation labelName="hdr_item_selected" defaultText="Items selected" />: <strong>{this.state.selectedRowKeys.length}</strong></h4>
                     <Alert className={this.state.alertDisplay} message={<Translation labelName="msg_info_some_obsolete_items" defaultText="There might be some obsolete items" />} type="info" showIcon />
                    <Checkbox
                        onChange={this.toggleViewSelectedCheck}
                        checked={isViewSelectedChecked}><Translation labelName="chk_view_selected" defaultText="View Selected Items" /></Checkbox>
                </div>
                <Table
                    columns={manageTowItemTableHeader}
                    dataSource={this.state.rows}
                    rowKey={'itemlot'}
                    rowSelection={rowSelection}
                    className="manage-tow-items__table"
                    loading={this.state.loading}
                    pagination={false}
                    bordered
                    size="small"
                    scroll={{ y: 300 }} />
                <Button type="primary" className="btn btn-default" loading={this.state.btnLoading} onClick={this.handleUpdate}>
                    <Translation labelName="btn_update" defaultText="UPDATE" />
                </Button>
            </div>
        );
    }
}

const mapStateToProps = ({ towItemsState }) => ({
    itemData: towItemsState.itemData
});

export default connect(mapStateToProps, null)(ManageTowItems);

ManageTowItems.propTypes = {
    items: PropTypes.arrayOf(PropTypes.object),
    getUpdatedItems: PropTypes.func,
    itemData: PropTypes.array,
    companyName: PropTypes.string,
    closeLoading: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/ManageTowItems/index.js